/**
 * Primary UI colors by canonical stakeholder code — mirrors `buxus-frontend`
 * `getStakeholderColors` / `constants.colors.js` (CRM `EC - Commander`, etc.).
 */

/** Default when profile / stakeholder is unknown — matches mobile `PRIMARY_ORANGE`. */
export const DEFAULT_STAKEHOLDER_PRIMARY_HEX = "#D52229";

/** Buxus primary red — shared by ER / EC / ET stakeholder chrome and registration banner. */
export const BUXUS_ER_FAMILY_PRIMARY_HEX = "#eb4d4d";

const STAKEHOLDER_PRIMARY_HEX: Record<string, string> = {
  "ER - Emergency Responder": BUXUS_ER_FAMILY_PRIMARY_HEX,
  "EC - Commander": BUXUS_ER_FAMILY_PRIMARY_HEX,
  "ET - Tier II": BUXUS_ER_FAMILY_PRIMARY_HEX,
  "EX - Excavator": "#f27e22",
  "FM - Farmer": "#67c480",
  "PO - Public Official": "#af38fa",
  "AP - Affected Public": "#168aef",
  "SC - School Rep": "#f5c72f",
  "OT - Other": "#434d5f",
};

/** Swatch for menus / legend — same hues as primary where applicable. */
export const STAKEHOLDER_MENU_SWATCH_HEX: Record<string, string> = {
  "Emergency Responder": "#eb4d4d",
  Commander: "#eb4d4d",
  "Tier II": "#eb4d4d",
  Excavator: "#f27e22",
  Farmer: "#67c480",
  "Public Official": "#af38fa",
  "Affected Public": "#168aef",
  "School Rep": "#f5c72f",
  Other: "#434d5f",
};

export function stakeholderPrimaryHexFromCanonical(
  canonicalStakeholderCode: string | null | undefined,
): string {
  if (!canonicalStakeholderCode?.trim()) return DEFAULT_STAKEHOLDER_PRIMARY_HEX;
  return (
    STAKEHOLDER_PRIMARY_HEX[canonicalStakeholderCode.trim()] ??
    DEFAULT_STAKEHOLDER_PRIMARY_HEX
  );
}
